module.exports = __webpack_public_path__ + "img/11_Splenic-Flexure.932a57a4.png";